import { useState, useEffect, useCallback } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import { getMonthlyPassAmount, getMonthlyOrderName } from './useTossMonthlyPayment';

const functions = getFunctions(getApp(), 'asia-northeast3');
const getPaymentSettingsFn = httpsCallable(functions, 'getPaymentSettings');

/**
 * 서버(Firestore AppSettings/payment) 기준 월 이용권 금액·상품명.
 * 호출 실패 시 환경 변수 폴백.
 */
export function usePaymentSettings() {
  const [amount, setAmount] = useState(() => getMonthlyPassAmount());
  const [orderName, setOrderName] = useState(() => getMonthlyOrderName());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await getPaymentSettingsFn();
      if (data?.amount != null && Number.isFinite(Number(data.amount))) {
        setAmount(Number(data.amount));
      }
      if (typeof data?.orderName === 'string' && data.orderName.trim()) {
        setOrderName(data.orderName.trim());
      }
    } catch (e) {
      setError(e?.message || '결제 설정을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { amount, orderName, loading, error, refresh };
}
